const actions = {
  SEARCH_REQUEST: "REVIEW_CRAWLING_SETTING/SEARCH_REQUEST",
  SEARCH_SUCCESS: "REVIEW_CRAWLING_SETTING/SEARCH_SUCCESS",
  SEARCH_ERROR: "REVIEW_CRAWLING_SETTING/SEARCH_ERROR",

  CREATE_REQUEST: "REVIEW_CRAWLING_SETTING/CREATE_REQUEST",
  CREATE_SUCCESS: "REVIEW_CRAWLING_SETTING/CREATE_SUCCESS",
  CREATE_ERROR: "REVIEW_CRAWLING_SETTING/CREATE_ERROR",

  DETAIL_REQUEST: "REVIEW_CRAWLING_SETTING/DETAIL_REQUEST",
  DETAIL_SUCCESS: "REVIEW_CRAWLING_SETTING/DETAIL_SUCCESS",
  DETAIL_ERROR: "REVIEW_CRAWLING_SETTING/DETAIL_ERROR",

  UPDATE_REQUEST: "REVIEW_CRAWLING_SETTING/UPDATE_REQUEST",
  UPDATE_SUCCESS: "REVIEW_CRAWLING_SETTING/UPDATE_SUCCESS",
  UPDATE_ERROR: "REVIEW_CRAWLING_SETTING/UPDATE_ERROR",

  DELETE_REQUEST: "REVIEW_CRAWLING_SETTING/DELETE_REQUEST",
  DELETE_SUCCESS: "REVIEW_CRAWLING_SETTING/DELETE_SUCCESS",
  DELETE_ERROR: "REVIEW_CRAWLING_SETTING/DELETE_ERROR",

  EXECUTE_REQUEST: "REVIEW_CRAWLING_SETTING/EXECUTE_REQUEST",
  EXECUTE_SUCCESS: "REVIEW_CRAWLING_SETTING/EXECUTE_SUCCESS",
  EXECUTE_ERROR: "REVIEW_CRAWLING_SETTING/EXECUTE_ERROR",

  CANCEL_REQUEST: "REVIEW_CRAWLING_SETTING/CANCEL_REQUEST",
  CANCEL_SUCCESS: "REVIEW_CRAWLING_SETTING/CANCEL_SUCCESS",
  CANCEL_ERROR: "REVIEW_CRAWLING_SETTING/CANCEL_ERROR",

  GET_CURRENT_REQUEST: "REVIEW_CRAWLING_SETTING/GET_CURRENT_REQUEST",
  GET_CURRENT_SUCCESS: "REVIEW_CRAWLING_SETTING/GET_CURRENT_SUCCESS",
  GET_CURRENT_ERROR: "REVIEW_CRAWLING_SETTING/GET_CURRENT_ERROR",

  GET_HISTORIES_REQUEST: "REVIEW_CRAWLING_SETTING/GET_HISTORIES_REQUEST",
  GET_HISTORIES_SUCCESS: "REVIEW_CRAWLING_SETTING/GET_HISTORIES_SUCCESS",
  GET_HISTORIES_ERROR: "REVIEW_CRAWLING_SETTING/GET_HISTORIES_ERROR",

  IMPORT_REQUEST: "REVIEW_CRAWLING_SETTING/IMPORT_REQUEST",
  IMPORT_SUCCESS: "REVIEW_CRAWLING_SETTING/IMPORT_SUCCESS",
  IMPORT_ERROR: "REVIEW_CRAWLING_SETTING/IMPORT_ERROR",

  VALIDATE_SETTING_FILE_REQUEST: "REVIEW_CRAWLING_SETTING/VALIDATE_SETTING_FILE_REQUEST",
  VALIDATE_SETTING_FILE_SUCCESS: "REVIEW_CRAWLING_SETTING/VALIDATE_SETTING_FILE_SUCCESS",
  VALIDATE_SETTING_FILE_ERROR: "REVIEW_CRAWLING_SETTING/VALIDATE_SETTING_FILE_ERROR",

  RESET_DETAIL: "REVIEW_CRAWLING_SETTING/RESET_DETAIL",

  search: (payload) => ({
    type: actions.SEARCH_REQUEST,
    payload,
  }),

  create: (payload) => ({
    type: actions.CREATE_REQUEST,
    payload,
  }),

  getDetail: (payload) => ({
    type: actions.DETAIL_REQUEST,
    payload,
  }),

  update: (payload) => ({
    type: actions.UPDATE_REQUEST,
    payload,
  }),

  delete: (payload) => ({
    type: actions.DELETE_REQUEST,
    payload,
  }),

  execute: (payload) => ({
    type: actions.EXECUTE_REQUEST,
    payload,
  }),

  cancel: (payload) => ({
    type: actions.CANCEL_REQUEST,
    payload,
  }),

  getCurrent: (payload) => ({
    type: actions.GET_CURRENT_REQUEST,
    payload,
  }),

  getHistories: (payload) => ({
    type: actions.GET_HISTORIES_REQUEST,
    payload,
  }),

  importExcel: (payload) => ({
    type: actions.IMPORT_REQUEST,
    payload,
  }),

  validateSettingFile: (payload) => ({
    type: actions.VALIDATE_SETTING_FILE_REQUEST,
    payload,
  }),

  resetDetail: () => ({
    type: actions.RESET_DETAIL,
  }),
};

export default actions;
